var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: { title: "Credit limit exceeded", label: "Proceed" },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c("div", { staticClass: "px-8 w-160" }, [
        _c(
          "div",
          {
            staticClass:
              "mb-4 w-full flex flex-col items-center gap-1 px-4 py-3 rounded bg-slate-200"
          },
          [
            _c("BlTextBody3", {
              attrs: { text: "Number of projected remaining credits:" }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "font-bold text-6xl text-dark-purple-100" },
              [_vm._v("\n        " + _vm._s(_vm.remainingCredits) + "\n      ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("BlTextBody2", {
              attrs: {
                text:
                  "The number of credits used for the appointment(s) will result in a deficit once the session(s) is completed. Do you still want to proceed with creating the appointment(s)?"
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-579228d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-579228d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/modal/CreditLimitExceededModal.vue
// module id = null
// module chunks = 